import Vue from "vue";
import Vuex from "vuex";
import scssVariables from "../../../sass/app.scss";

Vue.use(Vuex);

const state = {
    scssVariables: scssVariables
};

export const colorThemeVariables = new Vuex.Store({
    state
});
